<template>
  <div class="main">
    <div class="nav">
        <img class="nav_right" src="@/assets/images/logo/logo.jpg" >
        <img class="left" src="@/assets/images/mobile/right.png"  @click="popupShow">
    </div>
    <van-swipe style="height: 60vw;" :autoplay="3000" >
  <van-swipe-item v-for="(item,index) in defaultImg"  :key="index"  :default="item"></van-swipe-item>
</van-swipe>
    <router-view></router-view>
<div style="height: 28vw; background-color: #606060;color: #D3D3D3; font-size: 3vw;">
  <div style="padding-top: 2vw;">北京洁丽雅保洁有限公司</div>
  <div>备案号：京ICP63463468号 | 网站建设：雅思汀娜（北京）科技有限公司</div>
</div>
    <div class="main-navban">
      <div  style="width: 100vw;">
        <a href="tel:010-6396-7431" style="color: #ffffff; display: inline-flex; align-items: center; gap: 2vw;">
          <van-icon name="phone" size="4vw" />
          <span style="font-size: 4vw;">电话</span>
        </a>
      </div>
    </div>
     <van-popup v-model="show" position="right" :style="{ width: '60%',height:'100%' }">
      <van-cell-group>
  <van-cell
    v-for="item in navItems"
    :key="item.route"
    :title="item.title"
    is-link
    center
    @click="navigateToModule(item.route)"
  />
</van-cell-group>
     </van-popup>
  </div>
</template>

<script >
import home2 from '@/assets/images/mobile/home/2.jpg';
import home3 from '@/assets/images/mobile/home/3.jpg';
import home4 from '@/assets/images/mobile/home/4.jpg';
import home5 from '@/assets/images/mobile/home/5.jpg';
export default {
  name: "Home",
  data() {
    return {
      defaultImg: [
        home2,
        home3,
        home4,
        home5
      ],
      navItems: [
        { title: '首页', route: '/' },
        { title: '列车保洁', route: '/train-cleaning' },
        { title: '项目经验', route: '/project-experience' },
        { title: '科研革新', route: '/scientific-research' },
        { title: '新闻中心', route: '/news' },
        { title: '企业文化', route: '/corporate-culture' },
        { title: '关于我们', route: '/about' },
        { title: '联系我们', route: '/career' }
      ],
      show:false
    };
  },
  methods: {
    navigateToModule(route) {
      this.show = false;
      this.$router.push(route);
    },
    popupShow(){
      this.show=!this.show
    },
    goToNewsDetail(data) {
      const targetRoute = this.$router.resolve(`/news/detail${data}`);
      window.open(targetRoute.href, "_blank");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.nav {
  height: 15vw;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.nav .nav_right {
  width: 70vw;
  height: auto;
}
.nav .left {
  width: 5vw;
  height: auto;
  margin-right: 3vw;
}
.left{
  padding-top: 4vw;
  padding-bottom: 3vw;
}
.phone {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffb400;
  width: 100%;
  height: 20vw;
  background-color: rgba(55, 55, 55, 1);
  background-size: cover;
  background-position: center;
}
.content {
    font-size: 3vw;
    margin-top: 5vw;
    margin-bottom: 5vw;
    img {
        width: 25vw;
        margin: 0 1vw;
    }
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #696969;
    .content_chara{
        display: flex; 
        justify-content: center; align-items:center;flex-direction: column;width: 30vw;
    }
}
.main-navban {
  position: fixed;
  left: 0;
  width: 100%;
  right: 0px;
  z-index: 100;
  bottom: -1px;
  height: 15vw;
  background: rgba(101, 190, 186,1);
  display: flex;
  justify-content: center;
  align-items: center;
  &-left {
    flex: 1;
    font-size: 12px;
    display: flex;
    height: 82px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    line-height: 1.5em;
    color: rgba(0, 0, 0, 0.3);
  }
  &-right {
    flex: 2;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    margin-right: 2%;
    text-align: center;
    border-radius: 60px;
    color: #ffffff;
    background: linear-gradient(110deg, #1fcb43 -1%, #fffda4 129%);
  }
}
.news-list {
  padding: 4vw;
  .news-item {
    display: flex;
    margin-bottom: 4vw;
    .news-img {
      width: 30vw;
      height: 20vw;
      object-fit: cover;
      margin-right: 3vw;
    }
    .news-content {
      flex: 1;
      h5 {
        font-size: 4vw!important;
        width: 60vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: inherit;
      }
      .news-desc {
        font-size: 3.5vw;
        color: #6B6B6B;
        margin-bottom: 1vw;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .news-time {
        padding: 1.5vw 5vw;
        font-size: 3vw;
        color: #515151;
        text-align: left;
      }
    }
  }
}
</style>